<template>
    <HeadersAuth/>
    <div class="flex justify-center items-center min-h-screen p-12">
        <div class="max-w-[500px] w-full m-auto bg-white px-12 py-10 shadow-[0_4px_38px_rgba(0,0,0,0.12)] rounded-lg">
            <img src="@/assets/logo.png" alt="logo" class="mx-auto mb-12"/>
            <h1 class="font-semibold text-4xl leading-tight text-[#373737] text-center">Forgot Password</h1>
            <p class="text-base text-[#575757] pt-4 text-center">Enter email to get OTP !</p>

            <span>
                <span>
                    <div class="pt-7">
                        <label class="input-label">Email <span class="text-red-500">*</span></label>
                        <input class="form-control h-[52px] text-[15px] placeholder:text-[15px]" type="email" placeholder="Please enter your email" v-model="checkEmail"/>
                        <p class="text-red-600" v-if="fieldRequired">Email is required.</p>
                    </div>
                    <div class="pt-10">
                        <button type="submit" :disabled="btnLoader" :class="btnLoader == true ? 'opacity-50 cursor-not-allowed' : ''" @click="clickToSendOPTEmail()" class="h-[60px] bg-blue-500 rounded text-lg font-semibold p-3 text-white text-center relative block w-full">
                            Send OTP
                        </button>
                    </div>
                </span>
                
                <p class="pt-6 text-center">Already registered ? <router-link to="/login" class="text-blue-500 font-medium"> Login</router-link></p>
            </span>
        </div>
    </div>
      <!-- <FooterSection/> -->
</template>
               
<script>
    import HeadersAuth from './HeadersAuth.vue';
    // import FooterSection from './FooterSection.vue';
    import { BASE_URL } from "../../config";
    import axios from "axios";
    import { createToast } from 'mosha-vue-toastify';
    import 'mosha-vue-toastify/dist/style.css';
    import { createLocal } from 'the-storages';

    const mirror = createLocal();
    const storage = mirror._prx;

    export default {
        name: 'LogIn',
        components:{
            HeadersAuth,
            // FooterSection,
        },

        data() {
          return {
            storage: storage,
            checkEmail:'',
            btnLoader: false,
            fieldRequired: false,   
          }
        },

        methods:{           
            async clickToSendOPTEmail(){         
                
                if(this.checkEmail == ''){
                  this.fieldRequired = true; 
                    return;
                }   

                this.btnLoader = true
                const formData ={
                                    "email": this.checkEmail,
                                    "ipAddress": this.storage.ipAddress,
                                    "user_type": "company",
                                };

                console.log(formData);
                await axios.post(BASE_URL + '/check-email',formData)
                .then((response)=>{
                    console.log(response.data);
                    this.tostMessage(response.data.success, response.data.message);
                    if(response.data.success == 'success'){
                        console.log("Responce: ",response.data.details);
                        this.btnLoader = false;    
                        this.$router.push({path: '/reset-password', query: { email: this.checkEmail }});
                        // this.showSentOTPDiv = true;
                    }
                })
                this.btnLoader = false     
                
            },

            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                    type: status,
                    timeout: 2500,
                    position: 'bottom-right',
                    showIcon: 'true'
                })
            },
        }
    }
</script>